/* Beton Atelier — Hero "Der Guss" (scroll-gesteuerte SVG-Animation)
   Portiert aus design_handoff_beton_atelier / Beton Atelier.dc.html */
(function () {
  'use strict';

  var track = document.getElementById('heroTrack');
  if (!track) return;

  var ids = ['ovTitle', 'ovHint', 'ovCap', 'phWrap', 'ph0', 'ph1', 'ph2', 'phBar', 'deco', 'spout', 'stream', 'flow1', 'flow2', 'splash', 'fillG', 'fillRect', 'surfLine', 'ghost', 'moldL', 'moldR', 'cabL', 'cabR', 'ancL', 'ancR', 'blade', 'pct', 'pctTick', 'pctText', 'gVase', 'wetOv', 'shadow', 'dust0', 'dust1', 'dust2', 'dust3', 'plant0', 'plant1', 'plant2', 'dims'];
  var E = {};
  ids.forEach(function (i) { E[i] = document.getElementById(i); });

  var scrollLen = parseInt(track.getAttribute('data-scroll-length') || '480', 10);
  var plantsN = parseInt(track.getAttribute('data-plants') || '3', 10);
  var phasesOn = track.getAttribute('data-phases') !== 'false';
  track.style.height = scrollLen + 'vh';
  if (!phasesOn && E.phWrap) E.phWrap.style.display = 'none';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var p = 0;

  /* Smooth-Scroll für Anker-Links, Offset -76px (fixe Nav) */
  document.querySelectorAll('[data-ba-nav]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var key = a.getAttribute('data-ba-nav');
      if (key === 'top') { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      var t = document.getElementById(key);
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 76, behavior: 'smooth' });
    });
  });

  function seg(a, b) { var v = (p - a) / (b - a); return v < 0 ? 0 : v > 1 ? 1 : v; }
  function eio(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function eoc(t) { return 1 - Math.pow(1 - t, 3); }
  function eiq(t) { return t * t; }

  function apply() {
    var tT = seg(0, 0.07);
    E.ovTitle.style.opacity = String(1 - tT);
    E.ovTitle.style.transform = 'translateY(' + (-36 * tT) + 'px)';
    E.ovHint.style.opacity = String(1 - seg(0, 0.045));

    var spIn = eoc(seg(0.02, 0.07));
    var spOut = eiq(seg(0.385, 0.45));
    E.spout.setAttribute('transform', 'translate(0,' + (-120 * (1 - spIn) - 140 * spOut) + ')');
    E.spout.setAttribute('opacity', String(Math.min(spIn * 1.4, 1) * (1 - seg(0.40, 0.46))));

    var f = eio(seg(0.07, 0.36));
    var fillY = 700 - 260 * f;
    E.fillRect.setAttribute('y', String(fillY));
    E.fillRect.setAttribute('height', String(700 - fillY + 2));
    E.surfLine.setAttribute('y', String(fillY - 1.2));
    var cu = seg(0.40, 0.52);
    var mixc = function (a, b) { return Math.round(a + (b - a) * cu); };
    E.fillRect.setAttribute('fill', 'rgb(' + mixc(126, 169) + ',' + mixc(118, 162) + ',' + mixc(108, 152) + ')');
    E.fillG.setAttribute('opacity', String(Math.min(seg(0.055, 0.08) * 1.2, 1) * (1 - seg(0.525, 0.56))));
    E.ghost.setAttribute('opacity', String(0.30 * (1 - seg(0.07, 0.16))));

    var sOn = seg(0.055, 0.075);
    var pourLive = 1 - seg(0.375, 0.395);
    var drop = eoc(seg(0.05, 0.078));
    var sTop = 392 + (fillY - 392) * eiq(seg(0.34, 0.385));
    var sEnd = 392 + (fillY + 2 - 392) * drop;
    var active = sOn > 0 && pourLive > 0 && sTop < sEnd - 1;
    E.stream.setAttribute('points', '493.5,' + sTop + ' 506.5,' + sTop + ' 505,' + sEnd + ' 495,' + sEnd);
    E.stream.setAttribute('opacity', String(active ? sOn * pourLive : 0));
    var fls = [E.flow1, E.flow2];
    for (var i = 0; i < 2; i++) {
      fls[i].setAttribute('y1', String(Math.min(sTop + 4, sEnd - 3)));
      fls[i].setAttribute('y2', String(sEnd - 2));
      fls[i].setAttribute('stroke-dashoffset', String(-(p * 2800) - i * 9));
      fls[i].setAttribute('opacity', String(active ? 0.5 * pourLive : 0));
    }
    E.splash.setAttribute('transform', 'translate(0,' + fillY + ')');
    E.splash.setAttribute('opacity', String(active ? 0.55 * seg(0.075, 0.085) * (1 - seg(0.335, 0.375)) : 0));

    var pctO = Math.min(seg(0.075, 0.105), 1 - seg(0.36, 0.41));
    E.pct.setAttribute('opacity', String(pctO * 0.75));
    if (pctO > 0) {
      E.pctText.textContent = Math.round(f * 100) + ' %';
      E.pctTick.setAttribute('y1', String(fillY));
      E.pctTick.setAttribute('y2', String(fillY));
      E.pctText.setAttribute('y', String(fillY + 3.5));
    }

    var bl = seg(0.39, 0.46);
    E.blade.setAttribute('transform', 'translate(' + (414 + 172 * eio(bl)) + ',0)');
    E.blade.setAttribute('opacity', String(Math.sin(Math.PI * bl) * 0.9));

    var gap = 26 * eoc(seg(0.52, 0.57)) + 150 * eio(seg(0.585, 0.72));
    var lift = -150 * eio(seg(0.60, 0.74));
    var mO = 1 - seg(0.72, 0.79);
    E.moldL.setAttribute('transform', 'translate(' + (-gap) + ',' + lift + ')');
    E.moldR.setAttribute('transform', 'translate(' + gap + ',' + lift + ')');
    E.moldL.setAttribute('opacity', String(mO));
    E.moldR.setAttribute('opacity', String(mO));
    E.cabL.setAttribute('x2', String(392 - gap));
    E.cabL.setAttribute('y2', String(420 + lift));
    E.cabR.setAttribute('x2', String(608 + gap));
    E.cabR.setAttribute('y2', String(420 + lift));
    var cabO = String(mO * 0.9);
    E.cabL.setAttribute('opacity', cabO);
    E.cabR.setAttribute('opacity', cabO);
    E.ancL.setAttribute('opacity', cabO);
    E.ancR.setAttribute('opacity', cabO);

    var vO = seg(0.525, 0.56);
    var tf = seg(0.575, 0.685);
    var vy = -170 * (1 - eiq(tf));
    var st = seg(0.685, 0.745);
    vy += 4.5 * Math.sin(Math.PI * Math.min(st, 1)) * (1 - st * 0.7);
    E.gVase.setAttribute('opacity', String(vO));
    E.gVase.setAttribute('transform', 'translate(0,' + vy + ')');
    E.wetOv.setAttribute('opacity', String(1 - seg(0.56, 0.67)));

    var sh = seg(0.60, 0.685);
    E.shadow.setAttribute('opacity', String(0.09 * Math.min(seg(0.02, 0.1) * 4, 1) * mO + 0.34 * sh));
    E.shadow.setAttribute('rx', String(108 - 38 * sh));

    var du = seg(0.685, 0.775);
    var dOp = du > 0 ? Math.sin(Math.PI * Math.min(du * 1.1, 1)) * 0.4 : 0;
    var dirs = [-1, 1, -1, 1];
    var dist = [44, 44, 28, 28];
    var dusts = [E.dust0, E.dust1, E.dust2, E.dust3];
    for (var d = 0; d < 4; d++) {
      dusts[d].setAttribute('transform', 'translate(' + (dirs[d] * dist[d] * eoc(du)) + ',' + (-6 * eoc(du)) + ')');
      dusts[d].setAttribute('opacity', String(dOp));
    }

    E.dims.setAttribute('opacity', String(seg(0.74, 0.83) * 0.7));

    var starts = [0.71, 0.775, 0.84];
    var pivots = [498, 492, 508];
    var plants = [E.plant0, E.plant1, E.plant2];
    for (var k = 0; k < 3; k++) {
      if (k >= plantsN) { plants[k].setAttribute('opacity', '0'); continue; }
      var t = seg(starts[k], starts[k] + 0.105);
      plants[k].setAttribute('opacity', t > 0 ? '1' : '0');
      var rot = -9 * (1 - eoc(t));
      plants[k].setAttribute('transform', 'translate(0,' + (-640 * (1 - eiq(t))) + ') rotate(' + rot + ' ' + pivots[k] + ' 620)');
    }

    var cO = seg(0.94, 0.98);
    E.ovCap.style.opacity = String(cO);
    E.ovCap.style.transform = 'translateY(' + ((1 - cO) * 16) + 'px)';
    E.ovCap.style.pointerEvents = cO > 0.5 ? 'auto' : 'none';

    if (phasesOn) {
      var a0 = Math.min(seg(0.025, 0.06), 1 - seg(0.48, 0.52));
      var a1 = Math.min(seg(0.50, 0.54), 1 - seg(0.69, 0.73));
      var a2 = Math.min(seg(0.71, 0.75), 1 - seg(0.96, 0.995));
      var phs = [[E.ph0, a0], [E.ph1, a1], [E.ph2, a2]];
      for (var j = 0; j < 3; j++) {
        phs[j][0].style.opacity = String(phs[j][1]);
        phs[j][0].style.transform = 'translateY(' + ((1 - phs[j][1]) * 8) + 'px)';
      }
      E.phBar.style.height = (p * 150) + 'px';
    }

    E.deco.setAttribute('transform', 'translate(500 620) scale(' + (0.97 + 0.06 * p) + ') translate(-500 -620)');
  }

  function tick() {
    var r = track.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    var raw = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
    var k = reduced ? 1 : 0.16;
    p += (raw - p) * k;
    if (Math.abs(raw - p) < 0.0004) p = raw;
    apply();
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
